import React from "react";
import { FaFilePdf } from "react-icons/fa";
import filmshooting from "../../assets/documents/Film_Shooting_GR.pdf";
import { useSelector } from "react-redux";
import { convertToMarathiNumber } from "../../components/marathiNumbers";
import { Link } from "react-router-dom";

const FilmShooting = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Film / Video Shooting",
      divisionTitle: "HOME",
      breadcrumb: "FILM / VIDEO SHOOTING",
      paragraph: `Taking into consideration the Government’s policy of Ease of doing business, a meeting was held with the Hon’ble Chief Minister on 18th September, 2015. In this regard, the matter of implementing a single window scheme was under the consideration of the government in order to get the permits of various departments required for shooting of movies, TV serials, commercials, documentaries, etc. with ease and within a certain time frame.`,
      paragraph1: `Mumbai Metropolitan Region Development Authority and Mumbai Metro Rail Corporation Ltd. will be able to apply the system under the window scheme if they have declared available locations for filming on the website https://www.filmcell.maharashtra.gov.in/sws/. `,
      paragraph2: `However, for those locations which are not available on the website https://www.filmcell.maharashtra.gov.in/sws/ (Maharashtra Filmcell) or where filming is restricted/prohibited as per law, separate permission for filming shall be obtained from the respective organization/s.`,
    },
    मराठी: {
      title: "चित्रपट/व्हिडिओ शूटिंग",
      divisionTitle: "मुख्यपृष्ठ ",
      breadcrumb: "चित्रपट/व्हिडिओ शूटिंग",
      paragraph: `व्यवयास करण्यासाठी सुलभता (Ease of doing business) या विषयाबाबतचे शासनाचे धोरण लक्षात घेऊन या संदर्भात दि. १८.०९.२०१५ रोजी मा. मुख्यमंत्री महोदयांकडे झालेल्या बैठकीतील निर्णयानुसार चित्रपट, टि. व्ही. मालिका, जाहिरातपट व माहितीपट इत्यादींच्या चित्रिकरणासाठी लागणाऱ्या विविध विभागांच्या परवानग्या सुलभरीतीने व ठराविक मुदतीमध्ये मिळाव्यात यादृष्टिने एक खिडकी योजना राबविण्याची बाब शासनाच्या विचारधीन होती`,
      paragraph1: `मुंबई महानगर प्रदेश विकास प्राधिकरण व मुंबई मेट्रो रेल कॉर्पोरेशन लि. या संस्थांनी https://www.filmcell.maharashtra.gov.in/sws/ या संकेतस्थळावर त्यांच्याकडील चित्रीकरणासाठी उपलब्ध स्थळे घोषित केली असतील तर त्यासाठी  एक खिडकी योजनेंतर्गत चित्रीकरणाची परवानगी आणि व्यवस्था सुलभतेने लागू करणे शक्य होईल. `,
      paragraph2: `तथापि जी  स्थळे https://www.filmcell.maharashtra.gov.in/sws/ (महाराष्ट्र फिल्मसेल) या संकेतस्थळावर उपलब्ध असणार नाहीत वा कायद्यान्वये चित्रीकरणास मर्यादित/प्रतिबंधित केली आहेत, अशा स्थळांसाठी त्या त्या संबंधित संस्थांची चित्रिकरणासाठी स्वतंत्र परवानगी घ्यावी लागेल.
	पुरातत्त्व व वस्तुसंग्रहालये संचालनालय च्या अंतर्गत असणाऱ्या स्थळांमध्ये चित्रीकरण करण्यासाठी`,
    },
  };

  const tableHeaders = {
    srNo: {
      English: "Sr. No.",
      मराठी: "अ.क्र.",
    },
    name: {
      English: "Name",
      मराठी: "नाव",
    },
    download: {
      English: `Download`,
      मराठी: `डाउनलोड`,
    },
  };

  const downloadData = [
    {
      id: 1,
      name: {
        English: "Film Shooting GR",
        मराठी: "चलचित्र चित्रीकरण शासन निर्णय",
      },
      download: filmshooting,
    },
  ];

  const t = content[selectedLang];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        {/* <p className="text-[13px] sm:text-base md:text-lg lg:text-xl  text-[#DD9827] mt-4">HOME / <span className="text-black">FILM SHOOTING</span></p> */}
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.divisionTitle}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb}
        </p>
      </div>

      {/* Description Section */}
      <div className="max-w-7xl mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black leading-relaxed space-y-4 mt-12 font-futura">
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph}
        </p>

        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph1}
        </p>

        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph2}
        </p>
      </div>

      {/* Download Section */}
      {/* <h2 className="text-center text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-8 mt-12">
        {t.downloadTitle}
      </h2> */}

      <div className="max-w-5xl mx-auto overflow-x-auto no-dark-bg mt-12">
        <div
          className="bg-[#EFEDE0] rounded-xl overflow-hidden"
          style={{ border: "2px solid #F8D6BF" }}
        >
          <table className="min-w-full text-center text-black text-sm sm:text-base">
            <thead
              className="font-bold tracking-wide"
              style={{
                textShadow: "0.3px 0.3px 0 black",
              }}
            >
              <tr>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.srNo[selectedLang]}
                </th>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.name[selectedLang]}
                </th>
                <th className="py-3 px-4" style={{ borderColor: "#F8D6BF" }}>
                  {tableHeaders.download[selectedLang]}
                </th>
              </tr>
            </thead>
            <tbody>
              {downloadData.map((item, index) => (
                <tr key={item.id} className="hover:bg-[#F6F6EC]">
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {selectedLang === "मराठी"
                      ? convertToMarathiNumber(index + 1)
                      : `${index + 1}`}
                    .
                  </td>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {item.name[selectedLang]}
                  </td>
                  <td
                    className="py-3 px-4 border-t-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    <div className="flex justify-center items-center h-full">
                      <a
                        href={item.download}
                        download="Film Shooting PErmission GR"
                        title="Download PDF"
                        className="text-red-600 hover:text-red-800"
                      >
                        <FaFilePdf size={20} />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Link */}
        <div className="text-[14px] sm:text-lg md:text-xl mt-8 lg:text-[20px] flex justify-center">
          <a
            href="https://www.filmcell.maharashtra.gov.in/sws/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 sm:mt-5 px-3 sm:px-5 py-1 sm:py-2 text-[13px] sm:text-[11px] md:text-sm bg-transparent border border-black 
                    rounded-full  hover:bg-orange-500 hover:text-white hover:border-transparent transition font-futura font-semibold tracking-widest"
          >
            Link
          </a>
        </div>
      </div>
    </div>
  );
};

export default FilmShooting;
